import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { UserIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/host-management/$clubid')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="manageStoreInformation.basicStore.crumb.hostManagement" icon={UserIcon} />,
      title: <Translation id="storeManagement.hostManagement.manageHost.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
